module.exports = __webpack_public_path__ + "img/C-suite_bc.04efec89.svg";